"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreDefinitionMap = void 0;
const ModelCommon_1 = require("../ModelCommon");
// Maps between Entity Type and Attribues of its scoring
const typeName = 'ScoreDefinitionMap';
/** @deprecated in favour of `ScoreConfig` */
class ScoreDefinitionMap extends ModelCommon_1.ModelCommon {
    constructor(name, initMap) {
        super(typeName, {});
        this.name = name ?? 'ScoreDefinitionMap';
        this.map = { ...initMap };
    }
}
exports.ScoreDefinitionMap = ScoreDefinitionMap;
